import React, { useState, useEffect } from "react";
import { getCountryCodeAction } from "../../Action/propertyOwner.action";
import { getUserProfileInfos } from "../../Action/user.action";
import Select from "react-select";
import { Card } from "react-bootstrap";
import "../commanComponents/componentCSS/guestform.css";

const GuestFormGlobal = ({ onStatusChange, onSubmitFormData, occupancies, rateId }) => {
    const [formData, setFormData] = useState({
        email: "",
        countryCode: "",
        phone: "",
        addressLine1: "",
        addressLine2: "",
        country: "",
        state: "",
        city: "",
        zipCode: "",
    });

    const [rooms, setRooms] = useState([]);
    const [formErrors, setFormErrors] = useState({});
    const [guestErrors, setGuestErrors] = useState([]);
    const [countryCodeOption, setCountryOption] = useState([]);
    const [countryCode, setcountryCode] = useState({
        label: "+592",
        value: "592",
    });

    useEffect(() => {
        getCountryCodeAPI();
    }, []);

    useEffect(() => {
        if (countryCodeOption.length > 0) {
            getUserProfileDetailAPI();
        }
    }, [countryCodeOption]);

    // Build initial rooms structure based on occupancies
    useEffect(() => {
        if (occupancies?.length) {
            const initialRooms = occupancies.map((room) => {
                const adults = Array.from({ length: parseInt(room.numOfAdults) }, () => ({
                    title: "",
                    firstName: "",
                    lastName: "",
                    age: "",
                    type: "adult",
                }));

                const children = Array.from({ length: parseInt(room.numOfChildren) }, (_, i) => ({
                    title: "",
                    firstName: "",
                    lastName: "",
                    age: room.childAges?.[i] || "",
                    type: "child",
                }));

                return {
                    roomId: room.roomId,
                    rateId: rateId, // attach rateId from props
                    guests: [...adults, ...children],
                };
            });

            setRooms(initialRooms);
            setGuestErrors(initialRooms.map(() => []));
        }
    }, [occupancies, rateId]);

    const getCountryCodeAPI = async () => {
        let res = await getCountryCodeAction();
        if (res.success) {
            const options = res.data.map((x) => ({
                label: `+${x.phonecode}`,
                value: x.phonecode.toString(),
            }));
            setCountryOption(options);
            const guyana = options.find((opt) => opt.value === "592");
            if (guyana) {
                setcountryCode(guyana);
                setFormData((prev) => ({ ...prev, countryCode: guyana.value }));
            }
        }
    };

    const getUserProfileDetailAPI = async () => {
        let res = await getUserProfileInfos();
        if (res.success) {
            const { email, mobileNumber, countryCode, address } = res.data;
            setFormData((prev) => ({
                ...prev,
                email: email || "",
                phone: mobileNumber || "",
                addressLine1: address !== "null" ? address : "",
                countryCode: countryCode?.toString() || "",
            }));

            const selectedCode = countryCodeOption.find(
                (opt) => opt.value === countryCode?.toString()
            );
            if (selectedCode) {
                setcountryCode(selectedCode);
            }
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        setFormErrors((prev) => ({ ...prev, [name]: "" }));
    };

    const handleGuestChange = (roomIndex, guestIndex, e) => {
        const { name, value } = e.target;
        const updatedRooms = [...rooms];
        updatedRooms[roomIndex].guests[guestIndex][name] = value;
        setRooms(updatedRooms);

        const updatedErrors = [...guestErrors];
        if (updatedErrors[roomIndex]?.[guestIndex]) {
            updatedErrors[roomIndex][guestIndex][name] = "";
            setGuestErrors(updatedErrors);
        }
    };

    const validate = () => {
        const errors = {};
        const guestErrs = rooms.map((room) =>
            room.guests.map((guest) => {
                const gErr = {};
                if (!guest.title) gErr.title = "Please select a title";
                if (!guest.firstName) gErr.firstName = "First name is required";
                if (!guest.lastName) gErr.lastName = "Last name is required";
                if (!guest.age) gErr.age = "Age is required";
                return gErr;
            })
        );

        if (!formData.email) {
            errors.email = "Email is required";
        }

        if (!formData.countryCode) {
            errors.countryCode = "Country code is required";
        }

        if (!formData.phone) {
            errors.phone = "Phone number is required";
        } else if (!/^\d{7,15}$/.test(formData.phone)) {
            errors.phone = "Phone number must be between 7 and 15 digits";
        }

        if (!formData.addressLine1) errors.addressLine1 = "Address Line 1 is required";
        if (!formData.country) errors.country = "Country is required";
        if (!formData.state) errors.state = "State/Region is required";
        if (!formData.city) errors.city = "City/Town/Village is required";

        return { errors, guestErrs };
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const { errors, guestErrs } = validate();

        if (
            Object.keys(errors).length > 0 ||
            guestErrs.some((room) => room.some((err) => Object.keys(err).length > 0))
        ) {
            setFormErrors(errors);
            setGuestErrors(guestErrs);
            onStatusChange(false);
            return;
        }

        try {
            // ✅ Build roomsAllocations
            const roomsAllocations = rooms.map((room) => ({
                roomid: room.roomId,
                rateid: room.rateId,
                guests: room.guests.map((guest) => ({
                    type: guest.type === "adult" ? "Adult" : "Child",
                    title: guest.title,
                    firstname: guest.firstName,
                    lastname: guest.lastName,
                    age: guest.age,
                    email: formData.email, // common email
                })),
            }));

            onSubmitFormData({
                contactInfo: formData,
                roomsAllocations,
            });

            onStatusChange(true);
        } catch (error) {
            console.error("Error sending form data:", error);
            onStatusChange(false);
        }
    };

    const renderError = (field) =>
        formErrors[field] && (
            <div className="text-danger mt-1" style={{ fontSize: "0.875em" }}>
                {formErrors[field]}
            </div>
        );

    const renderGuestError = (roomIndex, guestIndex, field) =>
        guestErrors[roomIndex] &&
        guestErrors[roomIndex][guestIndex] &&
        guestErrors[roomIndex][guestIndex][field] && (
            <div className="text-danger mt-1" style={{ fontSize: "0.875em" }}>
                {guestErrors[roomIndex][guestIndex][field]}
            </div>
        );

    return (
        <div className="container mt-4 guestForm">
            <h5 className="fw-bold mb-3">Guest Information</h5>

            <form onSubmit={handleSubmit}>
                {rooms.map((room, rIndex) => (
                    <Card className="shadow-sm rounded-4 mb-4" key={rIndex}>
                        <Card.Body>
                            <h5 className="fw-semibold">Room {rIndex + 1}</h5>
                            {room.guests.map((guest, gIndex) => (
                                <div className="row mb-3" key={gIndex}>
                                    <h6>
                                        {guest.type === "adult"
                                            ? `Adult ${gIndex + 1}`
                                            : `Child ${gIndex + 1}`}
                                    </h6>
                                    <div className="col-3">
                                        <label className="form-label">Title</label>
                                        <select
                                            className="form-select"
                                            name="title"
                                            value={guest.title}
                                            onChange={(e) => handleGuestChange(rIndex, gIndex, e)}
                                        >
                                            <option value="">Select Title</option>
                                            <option value="Mr">Mr</option>
                                            <option value="Mrs">Mrs</option>
                                            <option value="Miss">Miss</option>
                                            <option value="Dr">Dr</option>
                                        </select>
                                        {renderGuestError(rIndex, gIndex, "title")}
                                    </div>
                                    <div className="col-3">
                                        <label className="form-label">First Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="firstName"
                                            value={guest.firstName}
                                            onChange={(e) => handleGuestChange(rIndex, gIndex, e)}
                                        />
                                        {renderGuestError(rIndex, gIndex, "firstName")}
                                    </div>
                                    <div className="col-3">
                                        <label className="form-label">Last Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="lastName"
                                            value={guest.lastName}
                                            onChange={(e) => handleGuestChange(rIndex, gIndex, e)}
                                        />
                                        {renderGuestError(rIndex, gIndex, "lastName")}
                                    </div>
                                    <div className="col-3">
                                        <label className="form-label">Age</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="age"
                                            value={guest.age}
                                            onChange={(e) => handleGuestChange(rIndex, gIndex, e)}
                                        />
                                        {renderGuestError(rIndex, gIndex, "age")}
                                    </div>
                                </div>
                            ))}
                        </Card.Body>
                    </Card>
                ))}

                {/* Contact Info */}
                <h5 className="fw-bold mb-3">Contact Information</h5>
                <Card className="shadow-sm rounded-4 mb-4">
                    <Card.Body>
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <label className="form-label">Email</label>
                                <input
                                    type="email"
                                    className="form-control h-auto rounded-2"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                />
                                {renderError("email")}
                            </div>

                            <div className="col-md-3">
                                <label className="form-label">Country Code</label>
                                <Select
                                    options={countryCodeOption}
                                    value={countryCode}
                                    onChange={(selectedOption) => {
                                        setcountryCode(selectedOption);
                                        setFormData((prev) => ({
                                            ...prev,
                                            countryCode: selectedOption.value,
                                        }));
                                    }}
                                    placeholder="Select code"
                                    classNamePrefix="react-select"
                                />
                                {renderError("countryCode")}
                            </div>

                            <div className="col-md-3">
                                <label className="form-label">Phone</label>
                                <input
                                    type="text"
                                    className="form-control h-auto rounded-2"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                />
                                {renderError("phone")}
                            </div>
                        </div>
                    </Card.Body>
                </Card>

                {/* Billing Info */}
                <h5 className="fw-bold mb-3">Billing Address</h5>
                <Card className="shadow-sm rounded-4 mb-4">
                    <Card.Body>
                        <div className="mb-3">
                            <label className="form-label">Address Line 1</label>
                            <input
                                type="text"
                                className="form-control h-auto rounded-2"
                                name="addressLine1"
                                value={formData.addressLine1}
                                onChange={handleChange}
                            />
                            {renderError("addressLine1")}
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Address Line 2</label>
                            <input
                                type="text"
                                className="form-control h-auto rounded-2"
                                name="addressLine2"
                                value={formData.addressLine2}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="row mb-3">
                            <div className="col">
                                <label className="form-label">Country</label>
                                <input
                                    type="text"
                                    className="form-control h-auto rounded-2"
                                    name="country"
                                    value={formData.country}
                                    onChange={handleChange}
                                />
                                {renderError("country")}
                            </div>
                            <div className="col">
                                <label className="form-label">State/Region</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="state"
                                    value={formData.state}
                                    onChange={handleChange}
                                />
                                {renderError("state")}
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col">
                                <label className="form-label">City/Town/Village</label>
                                <input
                                    type="text"
                                    className="form-control h-auto rounded-2"
                                    name="city"
                                    value={formData.city}
                                    onChange={handleChange}
                                />
                                {renderError("city")}
                            </div>
                            <div className="col">
                                <label className="form-label">Zip Code</label>
                                <input
                                    type="text"
                                    className="form-control h-auto rounded-2"
                                    name="zipCode"
                                    value={formData.zipCode}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </Card.Body>
                </Card>
                <button type="submit" className="btn btn-primary h-auto rounded-2">
                    Continue to Pay
                </button>
            </form>
        </div>
    );
};

export default GuestFormGlobal;
